export const HOMEPAGE_PATH = '/';
export const NOT_AUTHORIZED_PATH = '/not-authorized';
export const ERROR_PATH = '/error';
export const LOGIN_PATH = '/login';
export const LOGOUT_PATH = '/logout';
export const SIGNUP_PATH = '/sign-up';
export const IMPERSONATE_PATH = '/impersonate';
